package diana.soleil.design.iraniancanadienbazzar.feature.gems

import androidx.compose.foundation.layout.Arrangement
import androidx.compose.foundation.layout.Row
import androidx.compose.material3.Text
import androidx.compose.runtime.Composable
import androidx.compose.ui.Alignment
import diana.soleil.design.iraniancanadienbazzar.core.designsystem.component.AppIconButton
import diana.soleil.design.iraniancanadienbazzar.core.designsystem.component.ReportReason
import diana.soleil.design.iraniancanadienbazzar.core.designsystem.component.ReportSheet
import diana.soleil.design.iraniancanadienbazzar.core.designsystem.component.ReportStatus
import diana.soleil.design.iraniancanadienbazzar.core.designsystem.theme.AppTheme
import diana.soleil.design.iraniancanadienbazzar.core.model.formatCount
import diana.soleil.design.iraniancanadienbazzar.feature.gems.resources.Res
import diana.soleil.design.iraniancanadienbazzar.feature.gems.resources.gems_copy_a11y
import diana.soleil.design.iraniancanadienbazzar.feature.gems.resources.gems_like_a11y
import diana.soleil.design.iraniancanadienbazzar.feature.gems.resources.gems_more_a11y
import diana.soleil.design.iraniancanadienbazzar.feature.gems.resources.gems_report_done
import diana.soleil.design.iraniancanadienbazzar.feature.gems.resources.gems_report_failed
import diana.soleil.design.iraniancanadienbazzar.feature.gems.resources.gems_report_reason_offensive
import diana.soleil.design.iraniancanadienbazzar.feature.gems.resources.gems_report_reason_other
import diana.soleil.design.iraniancanadienbazzar.feature.gems.resources.gems_report_reason_spam
import diana.soleil.design.iraniancanadienbazzar.feature.gems.resources.gems_report_sent
import diana.soleil.design.iraniancanadienbazzar.feature.gems.resources.gems_report_submit
import diana.soleil.design.iraniancanadienbazzar.feature.gems.resources.gems_report_title
import diana.soleil.design.iraniancanadienbazzar.feature.gems.resources.gems_save_a11y
import diana.soleil.design.iraniancanadienbazzar.feature.gems.resources.gems_share_a11y
import org.jetbrains.compose.resources.stringResource

/**
 * The like / save / copy / share / report action row shared by the poem and story readers. The tale
 * reader predates this and keeps its own inline copy; consolidating it is a follow-up.
 */
@Composable
internal fun GemDetailRail(
    likeCount: Int,
    liked: Boolean,
    saved: Boolean,
    onToggleLike: () -> Unit,
    onToggleSave: () -> Unit,
    onCopy: () -> Unit,
    onShare: () -> Unit,
    onReport: () -> Unit,
) {
    val lang = AppTheme.language
    Row(
        horizontalArrangement = Arrangement.spacedBy(AppTheme.spacing.sm),
        verticalAlignment = Alignment.CenterVertically,
    ) {
        AppIconButton(
            iconName = "favorite",
            contentDescription = stringResource(Res.string.gems_like_a11y),
            onClick = onToggleLike,
            filled = liked,
            tint = if (liked) AppTheme.colors.error else AppTheme.colors.onSurfaceVariant,
        )
        Text(
            text = lang.formatCount(likeCount),
            style = AppTheme.typography.labelSm,
            color = AppTheme.colors.onSurfaceVariant,
        )
        AppIconButton(
            iconName = "bookmark",
            contentDescription = stringResource(Res.string.gems_save_a11y),
            onClick = onToggleSave,
            filled = saved,
            tint = if (saved) AppTheme.colors.primary else AppTheme.colors.onSurfaceVariant,
        )
        AppIconButton(
            iconName = "content_copy",
            contentDescription = stringResource(Res.string.gems_copy_a11y),
            onClick = onCopy,
            tint = AppTheme.colors.onSurfaceVariant,
        )
        AppIconButton(
            iconName = "share",
            contentDescription = stringResource(Res.string.gems_share_a11y),
            onClick = onShare,
            tint = AppTheme.colors.onSurfaceVariant,
        )
        AppIconButton(
            iconName = "more_vert",
            contentDescription = stringResource(Res.string.gems_more_a11y),
            onClick = onReport,
            tint = AppTheme.colors.onSurfaceVariant,
        )
    }
}

/** The report bottom sheet with the gems reason set, mapped from a [GemReportStatus]. */
@Composable
internal fun GemReportSheet(
    status: GemReportStatus,
    onSubmit: (reason: String) -> Unit,
    onDismiss: () -> Unit,
) {
    ReportSheet(
        title = stringResource(Res.string.gems_report_title),
        reasons = listOf(
            ReportReason(stringResource(Res.string.gems_report_reason_offensive), "offensive"),
            ReportReason(stringResource(Res.string.gems_report_reason_spam), "spam"),
            ReportReason(stringResource(Res.string.gems_report_reason_other), "other"),
        ),
        status = when (status) {
            GemReportStatus.Sending -> ReportStatus.Sending
            GemReportStatus.Sent -> ReportStatus.Sent
            GemReportStatus.Failed -> ReportStatus.Failed
            else -> ReportStatus.Idle
        },
        sentText = stringResource(Res.string.gems_report_sent),
        failedText = stringResource(Res.string.gems_report_failed),
        submitText = stringResource(Res.string.gems_report_submit),
        doneText = stringResource(Res.string.gems_report_done),
        onSubmit = onSubmit,
        onDismiss = onDismiss,
    )
}
